import React from 'react';
import PropTypes from 'prop-types';

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';

const StepControls = ({ isFirstStep, isLastStep, isNextDisabled, handleNext, handleBack }) => {
  const renderBackButton = () => {
    return (
      <Box display="flex" my={2} justifyContent="flex-start" mr="auto">
        <Button
          variant="outlined"
          style={{ marginRight: '8px' }}
          color="primary"
          onClick={handleBack}
        >
          Back
        </Button>
      </Box>
    );
  };

  const renderNextButton = () => {
    return (
      <Box display="flex" my={2} justifyContent="flex-end" ml="auto">
        <Button variant="contained" disabled={isNextDisabled} color="primary" onClick={handleNext}>
          {isLastStep ? 'Complete' : 'Next'}
        </Button>
      </Box>
    );
  };

  return (
    <>
      <Box width="100%" mt={3}>
        <Divider style={{ width: '100%' }} />
      </Box>
      <Grid container direction="row" justify="space-between" alignItems="center" spacing={2}>
        <Grid item xs={4} md={4}>
          {!isFirstStep && renderBackButton()}
        </Grid>
        <Grid item xs={4} md={4}>
          {renderNextButton()}
        </Grid>
      </Grid>
    </>
  );
};

StepControls.propTypes = {
  isFirstStep: PropTypes.bool,
  isLastStep: PropTypes.bool,
  isNextDisabled: PropTypes.bool,
  handleNext: PropTypes.func,
  handleBack: PropTypes.func
};

StepControls.defaultProps = {
  isFirstStep: false,
  isLastStep: false,
  isNextDisabled: false,
  handleNext: null,
  handleBack: null
};

export default StepControls;
